import { PartImageSearchRequest } from '@/api/api';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation } from '@tanstack/react-query';

export const useSubmitPartImageSearch = () => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  return useMutation({
    mutationFn: async (request: PartImageSearchRequest) => {
      const response = await api.tenants.createPartFinderReportFromImages(tenantId, request);
      return response.data.partImageIdentification;
    },
  });
};
